import {
  normalizeHostnamePart,
} from '@/features/domains/utils/custom-domain.util';

export const DEFAULT_SENDER_SUBDOMAIN = 'em';

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const normalizeSenderDomain = (value: string): string => normalizeHostnamePart(value);

export const normalizeSenderSubdomain = (value: string): string =>
  normalizeHostnamePart(value || DEFAULT_SENDER_SUBDOMAIN);

export const normalizeSenderEmail = (value: string): string => value.trim().toLowerCase();

export const normalizeSenderName = (value: string): string => value.trim();

export const isValidSenderEmail = (value: string): boolean =>
  EMAIL_REGEX.test(normalizeSenderEmail(value));

export const doesSenderEmailMatchDomain = (email: string, domain: string): boolean => {
  const normalizedEmail = normalizeSenderEmail(email);
  const normalizedDomain = normalizeSenderDomain(domain);

  if (!normalizedEmail.includes('@') || !normalizedDomain) {
    return false;
  }

  return normalizedEmail.split('@')[1] === normalizedDomain;
};

export const validateSenderDomainForm = ({ fromEmail }: { fromEmail: string }): string | null => {
  if (!isValidSenderEmail(fromEmail)) {
    return 'Please enter a valid sender email address';
  }

  return null;
};
